import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
Vue.use(Vuetify, {
  theme: {
    primary: '#4A76A8',
    secondary: '#424242',
    accent: '#4A76A8',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  customProperties: true,
  iconfont: 'mdi' // 'md' || 'mdi' || 'fa' || 'fa4'
})
